/**
 * 路由封装
 * 路由懒加载方式一：
 *    1. component: resolve => require(['../pages/Index.vue'],resolve)  // 路由懒加载
 * 路由懒加载方式二：
 *    1. 需要添加 syntax-dynamic-import (opens new window)插件，才能使 Babel 可以正确地解析语法,`cnpm install --save-dev @babel/plugin-syntax-dynamic-import`
 *    2. component: () => import('../pages/Cart.vue'), // 路由懒加载
 */
// 导入vue和vue-router
import Vue from 'vue'
import Router from 'vue-router'
// 导入页面组件
// import Login from '../pages/Login'
import Home from '../pages/Home'
import Index from '../pages/Index'

import Receipt from '../pages/Receipt'
import Reply from '../pages/Reply'
import Speak from '../pages/Speak'
import Posted from '../pages/Posted'
import SpeakReply from '../pages/SpeakReply'
import StickReply from '../pages/StickReply'

import company_About from '../pages/company/index'
import company_Factory from '../pages/company/factory'
import company_Honor from '../pages/company/honor'
import company_Leader from '../pages/company/leader'
import company_contact from '../pages/company/contact'

import example_Index from '../pages/example/index'
import example_buildings from '../pages/example/buildings'
import example_medical from '../pages/example/medical'
import example_industry from '../pages/example/industry'

import plat_index from '../pages/plat/index.vue'
import plat_show from '../pages/plat/show.vue'

import product_type_list from '../pages/product/type_list'
import product_centers from '../pages/product/index.vue'
import product_detail from '../pages/product/detail'

import intel_index from '../pages/scheme/index.vue'
import intel_city from '../pages/scheme/intel_city.vue'
import intel_industry from '../pages/scheme/intel_industry.vue'
import intel_agriculture from '../pages/scheme/intel_agriculture'
import intel_detail from '../pages/scheme/detail'



import news_Index from '../pages/news/index'
import news_Company from '../pages/news/company'
import news_Industry from '../pages/news/industry'
import news_Detail from '../pages/news/detail'
// import Cart from '../pages/Cart'
// import Order from '../pages/Order'
// import OrderConfirm from '../pages/OrderConfirm'
// import OrderList from '../pages/OrderList'
// import OrderPay from '../pages/OrderPay'
// import Alipay from '../pages/Alipay'
// 加载路由插件
Vue.use(Router)
// 导出路由
export default new Router({
  // 路由规则
  routes: [
    // 首页
    {
      path: '/',
      name: '首页',
      component: Home,
      redirect: '/index', // 重定向
      // 子路由
      children: [
        {
          path: 'index',
          name: '首页',
          component: Index,
        },
        {
          path: 'product/type_list/:firstid',
          name: 'product/type_list',
          component: product_type_list,
        },
        {
          path: 'product/detail/:id',
          name: 'product/detail',
          component: product_detail,
        },
        {
          path: 'product/index',
          name: 'product/index',
          component: product_centers,
        },
        {
          path: 'scheme/index',
          name: 'scheme/index',
          component: intel_index,
        },
        {
          path: 'scheme/detail/:id',
          name: 'scheme/detail',
          component: intel_detail,
        },
        {
          path: 'scheme/intel_agriculture',
          name: 'scheme/intel_agriculture',
          component: intel_agriculture,
        },
        {
          path: 'scheme/intel_industry',
          name: 'scheme/intel_industry',
          component: intel_industry,
        },
        {
          path: 'scheme/intel_city',
          name: 'scheme/intel_city',
          component: intel_city,
        },

        {
          path: '/plat/show',
          name: '/plat/show',
          component: plat_show,
        },
        {
          path: '/plat/index',
          name: '/plat/index',
          component: plat_index,
        },

        {
          path: '/company/index',
          name: '/company/index',
          component: company_About,
        },
        {
          path: '/company/factory',
          name: '/company/factory',
          component: company_Factory,
        },
        {
          path: '/company/honor',
          name: '/company/honor',
          component: company_Honor,
        },
        {
          path: '/company/leader',
          name: '/company/leader',
          component: company_Leader,
        },
        {
          path: '/company/contact',
          name: '/company/contact',
          component: company_contact,
        },


        {
          path: '/example/index',
          name: '/example/index',
          component: example_Index,
        },
        {
          path: '/example/buildings',
          name: '/example/buildings',
          component: example_buildings,
        },
        {
          path: '/example/industry',
          name: '/example/industry',
          component: example_industry,
        },
        {
          path: '/example/medical',
          name: '/example/medical',
          component: example_medical,
        },

        {
          path: 'product/:id', // 动态路由
          name: 'product',
          // component: Product,
          // component: resolve => require(['../pages/Product.vue'],resolve), // 路由懒加载
          component: () => import('../pages/Product.vue') // 路由懒加载
        },

        {
          path: '/news/index',
          name: '/news/index',
          component: news_Index,
        },
        {
          path: '/news/company',
          name: '/news/company',
          component: news_Company,
        },
        {
          path: '/news/industry',
          name: '/news/industry',
          component: news_Industry,
        },
        {
          path: '/news/detail/:id',
          name: '/news/detail',
          component: news_Detail,
        },
      ]
    },

    {
      path: '/Receipt/:id',
      name: 'Receipt',
      component: Receipt,
    },
    {
      path: '/Reply',
      name: 'Reply',
      component: Reply,
    },
    {
      path: '/Speak',
      name: 'Speak',
      component: Speak,
    },
    {
      path: '/SpeakReply',
      name: 'SpeakReply',
      component: SpeakReply,
    },
    {
      path: '/StickReply',
      name: 'StickReply',
      component: StickReply,
    },
    {
      path: '/Posted',
      name: 'Posted',
      component: Posted,
    },
    // 登录
    {
      path: '/login',
      name: 'login',
      // component: Login
      component: () => import('../pages/Login.vue') // 路由懒加载
    },
    // 购物车
    {
      path: '/cart',
      name: 'cart',
      // component: Cart
      component: () => import('../pages/Cart.vue') // 路由懒加载
    },
  ]
})
